import { render, staticRenderFns } from "./HostingCtaSection.vue?vue&type=template&id=743f6c6a&scoped=true&"
import script from "./HostingCtaSection.vue?vue&type=script&lang=js&"
export * from "./HostingCtaSection.vue?vue&type=script&lang=js&"
import style0 from "./HostingCtaSection.vue?vue&type=style&index=0&id=743f6c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743f6c6a",
  null
  
)

export default component.exports